// extracted by mini-css-extract-plugin
export default {"thumbnailContainer":"ThumbnailView_thumbnailContainer__uW7mb","thumbnailImage":"ThumbnailView_thumbnailImage__h7ONq","removeButton":"ThumbnailView_removeButton__zeFPg"};